import { ShapeOptions } from '@mui/system';

export const shapeOptions: Partial<ShapeOptions> = { borderRadius: 15 };

export default shapeOptions;
